import {Component} from '@angular/core';
import {ApiService} from './../../services/api.service';
import {FloatButtonCartService} from './../../components/floatButtonCart/floatButtonCart.service';
import {Router} from '@angular/router';
import {ToastyService} from 'ng2-toasty';

declare var $: any;

declare var Mercadopago: any;

@Component({
  selector: 'my-payment',
  template: require('./payment.component.html'),
  styles: [require('./payment.component.scss')]
})
export class PaymentComponent {

  public listProductos = [];
  public total: number = 0;
  public pais = JSON.parse(localStorage.getItem('pais'));
  public controlPay: any = false;
  public typeUser: number = 1;
  public listTypeDocument: any = [];
  private token: string = '';


//  subscription: Subscription;

  constructor(private _api: ApiService, private _router: Router, private _float: FloatButtonCartService, private _toasty: ToastyService) {
    if (localStorage.getItem('login')) {
      let user = JSON.parse(localStorage.getItem('login'));
      if (user.tipoUsuario == 'cliente') {
        this.typeUser = user.tipoCliente;
      }
    }
    else {
      this._router.navigateByUrl('404');
    }

    if (localStorage.getItem('carrito')) {
      let obj: any = JSON.parse(localStorage.getItem('carrito'));
      let array = [];
      for (let index in obj) {
        array.push(index);
      }
      if (array.length < 1) {
        this._router.navigateByUrl('404');
      }
      this._api.getProductoMulti(array).subscribe(
        result => {
          this.listProductos = result;
          for (let producto in this.listProductos) {
            this.listProductos[producto].cantidad = obj[this.listProductos[producto].idProducto];
            let precio = 0;
            switch (this.typeUser) {
              case 2:
                precio = this.listProductos[producto].precioNormal;
                break;
              case 3:
                precio = this.listProductos[producto].precioVip;
                break;
              default:
                precio = this.listProductos[producto].precioEventual;
                break;
            }
            this.total = this.total + (this.listProductos[producto].cantidad * precio);
            console.log(this.total);
          }
        }
      );
    }
    else {
      this._router.navigateByUrl('404');
    }

    this._api.getToken().subscribe(
      res => {
        this.token = res.token;
        this.controlPay = true;
        if (this.pais.idPais != 1) {
          this.loadTDC();
        }
        else {
          Mercadopago.setPublishableKey("APP_USR-2dc79673-b4a0-4801-ae39-df57d1093e8f");
          Mercadopago.getIdentificationTypes(function (status, res) {
            if (status) {
              console.log(status);
            }
            let optionsSelect = '';
            for (let i = 0; i < res.length; i++) {
              optionsSelect = optionsSelect + '<option value="' + res[i].id + '">' + res[i].name + '</option>';
            }
            $('#docType').html(optionsSelect);

          });
          Mercadopago.getPaymentMethod(function(status,res){
            console.log(status);
            console.log(res);
          });
        }
      }
    );
  }

  public paymentPaypal() {
    var api = this._api;
    var toasty = this._toasty;
    var router = this._router;
    var float = this._float;
    var total = this.total;
    var token = this.token;
    var user = JSON.parse(localStorage.getItem('login'));
    var client = require('braintree-web/client');
    var paypal = require('braintree-web/paypal');
    this.controlPay = false;

    toasty.success('Abriendo paypal espere unos segundos.');

    client.create({
      authorization: token
    }, function (clientErr, clientInstance) {

      if (clientErr) {
        toasty.error('Error en la creación de pasarela de pago');
        console.error('Error creating client:', clientErr);
        location.reload();
        return;
      }

      paypal.create({
        client: clientInstance
      }, function (err, paypalInstance) {
        if (err) {
          toasty.error('Error en acceso a paypal');
          console.error('Error paypal create:', err);
          location.reload();
        }

        paypalInstance.tokenize({
          flow: 'checkout', // Required
          amount: total, // Required
          currency: 'USD', // Required
          locale: 'en_US',
          enableShippingAddress: true,
          shippingAddressEditable: false,
          shippingAddressOverride: {
            recipientName: user.nombre,
            line1: user.direccion,
            city: user.ciudad
          }
        }, function (err, tokenizationPayload) {
          if (err) {
            toasty.error('Error en instancia de paypal');
            console.error('Error paypal instance:', err);
            location.reload();
          }
          else {
            toasty.success('Procesando pago espere unos segundos.');
            api.postTransaccion(tokenizationPayload.nonce, tokenizationPayload.type).subscribe(
              result => {
                console.log(result);
                toasty.success('Exito en la transacción.');
                float.limpiarCart();
                router.navigateByUrl('mis-compras/' + result.message[0].idFactura);
              },
              err => {
                toasty.error(err.toString());
                console.log(err);
                location.reload();
              }
            )
          }
        });
      });
    });

  }

  public paymentMercadoPago() {
    var toasty = this._toasty;
    var api = this._api;
    var float = this._float;
    var router = this._router;
    var tipoTarjeta = $('#typeCard').val();
    var form = document.querySelector('#payMercadoPago');
    var email = $('#emailMercadoPago').val();

    Mercadopago.setPublishableKey("APP_USR-2dc79673-b4a0-4801-ae39-df57d1093e8f");

    Mercadopago.createToken(form,
      function sdkResponseHandler(status, response) {
        if (status != 200 && status != 201) {
          console.log(response);
          toasty.error('Error en la información facilitada');
        } else {


          api.postTransaccionMercadoPago(response.id, email, tipoTarjeta).subscribe(
            result => {
              toasty.success('Exito en la transacción.');
              float.limpiarCart();

              $('#myModalMercadoPago').modal('hide');

              router.navigateByUrl('mis-compras/' + result.message[0].idFactura);
            },
            err => {
              toasty.error(err.toString());
              console.log(err);
            }
          );
        }
      }
    )
  }

  public loadTDC() {
    var client = require('braintree-web/client');
    var hosted = require('braintree-web/hosted-fields');
    var api = this._api;
    var toasty = this._toasty;
    var router = this._router;
    var float = this._float;
    var token = this.token;

    var form = document.querySelector('#my-sample-form');
    var submit = document.querySelector('#envioTDC');

    client.create({
      authorization: token
    }, function (clientErr, clientInstance) {
      if (clientErr) {
        toasty.error('Error en la creación de pasarela de pago');
        return;
      }

      hosted.create({
        client: clientInstance,
        styles: {
          'input': {
            'font-size': '16px',
            'font-family': 'roboto, verdana, sans-serif',
            'font-weight': 'lighter',
            'color': 'black'
          },
          ':focus': {
            'color': 'black'
          },
          '.valid': {
            'color': 'black'
          },
          '.invalid': {
            'color': 'black'
          }
        },
        fields: {
          number: {
            selector: '#card-number',
            placeholder: '4111 1111 1111 1111'
          },
          cvv: {
            selector: '#cvv',
            placeholder: '123'
          },
          expirationDate: {
            selector: '#expiration-date',
            placeholder: '10/2019'
          }
        }
      }, function (hostedFieldsErr, hostedFieldsInstance) {
        if (hostedFieldsErr) {
          toasty.error('Error en la creación de instancia de pago');
          return;
        }

        document.getElementById("spin-loading-1").remove();
        document.getElementById("spin-loading-2").remove();
        document.getElementById("spin-loading-3").remove();

        submit.removeAttribute('disabled');

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
            if (tokenizeErr) {
              toasty.error('Los datos del formulario son incorrectos');
              return;
            }

            // If this was a real integration, this is where you would
            // send the nonce to your server.
            toasty.success('Procesando pago espere unos segundos.');
            api.postTransaccion(payload.nonce, payload.type).subscribe(
              result => {
                console.log(result);
                toasty.success('Exito en la transacción.');
                float.limpiarCart();

                $('#myModal').modal('hide');

                router.navigateByUrl('mis-compras/' + result.message[0].idFactura);
              },
              err => {
                toasty.error(err.toString());
                console.log(err);
                location.reload();
              }
            );
          });
        }, false);
      });
    });
  }

}

/**
 * Created by Desarrollo KJ on 20/3/2017.
 */



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/payment/payment.component.ts